import {Controller} from "stimulus";

export default class extends Controller
{
    static targets = ["input", "search", "table", "clear", "loading", "filteredNum"];

    TABLE_ROWS = [];
    
    connect()
    {
        
        this.TABLE_ROWS = Array.from(this.tableTarget.lastElementChild.cloneNode(true).children);

        this.searchTarget.addEventListener("click", e =>
        {

            if(!this.inputTarget.value && !this.clearTarget.classList.contains("hidden"))
            {
                this.searchTarget.classList.add("hidden");
                this.loadingTarget.classList.remove("hidden");

                this.tableTarget.lastElementChild.innerHTML = "";
                this.tableTarget.lastElementChild.append(...this.TABLE_ROWS);

                this.loadingTarget.classList.add("hidden");
                this.searchTarget.classList.remove("hidden");
                this.clearTarget.classList.add("hidden");

                this.filteredNumTarget.innerHTML = "";

                return;
            }

            if(!this.inputTarget.value) return;

            let query = this.inputTarget.value.split(" ");
            
            this.searchTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");

            let filtered = this.TABLE_ROWS.filter(row =>
            {
                let text = row.textContent;
                return query.reduce((prev, curr) => prev && text.toLowerCase().includes(curr.toLowerCase()), true)
            });

            this.tableTarget.lastElementChild.innerHTML = "";
            this.tableTarget.lastElementChild.append(...filtered);

            this.loadingTarget.classList.add("hidden");
            this.searchTarget.classList.remove("hidden");
            this.clearTarget.classList.remove("hidden");

            this.filteredNumTarget.innerHTML = `(${filtered.length} filtered)`
        })

        this.clearTarget.addEventListener("click", e =>
        {
            this.inputTarget.value = "";
            this.filteredNumTarget.innerHTML = "";
            this.searchTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");
            this.clearTarget.classList.add("hidden");

            this.tableTarget.lastElementChild.innerHTML = "";
            this.tableTarget.lastElementChild.append(...this.TABLE_ROWS);

            this.loadingTarget.classList.add("hidden");
            this.searchTarget.classList.remove("hidden");
        })
    }
}